import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Link = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <g transform="translate(2.25 4.05)">
        <path
          d="M11.1,2.4H3.3A3.3,3.3,0,0,0,0,5.7V9.9a3.3,3.3,0,0,0,3.3,3.3h.3V11.4H3.3A1.5,1.5,0,0,1,1.8,9.9V5.7A1.5,1.5,0,0,1,3.3,4.2h7.8a1.5,1.5,0,0,1,1.5,1.5V9.9a1.5,1.5,0,0,1-1.5,1.5H7.8v1.8h3.3a3.3,3.3,0,0,0,3.3-3.3V5.7a3.3,3.3,0,0,0-3.3-3.3Z"
          transform="translate(0 -2.4)"
        />
        <path
          d="M17.5,8.8h-.3v1.8h.3A1.5,1.5,0,0,1,19,12.1v4.2a1.5,1.5,0,0,1-1.5,1.5H9.7a1.5,1.5,0,0,1-1.5-1.5V12.1a1.5,1.5,0,0,1,1.5-1.5H13V8.8H9.7a3.3,3.3,0,0,0-3.3,3.3v4.2a3.3,3.3,0,0,0,3.3,3.3h7.8a3.3,3.3,0,0,0,3.3-3.3V12.1a3.3,3.3,0,0,0-3.3-3.3Z"
          transform="translate(-1.6 -4)"
        />
      </g>
    </svg>
  );
};

Link.displayName = 'Link';
